"use client";

import { useClient } from "@/hooks/useClient";
import { countDownHandler } from "@/utils/global";
import { useEffect, useState } from "react";

const ProductCardCountDown = ({ flash_sale_end_date }) => {
  const [countDown, setCountDown] = useState(
    countDownHandler(flash_sale_end_date)
  );
  const { isClient } = useClient();

  useEffect(() => {
    const timer = setTimeout(() => {
      setCountDown(countDownHandler(flash_sale_end_date));
    }, 1000);

    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  return (
    isClient && (
      <div className="absolute bottom-1.5 max-sm:bottom-[1px] end-0 z-30">
        <span className="flex w-fit gap-1 rounded-b-md bg-[#C1FF00] px-4 py-1 max-md:px-3 ltr:flex-row-reverse max-md:py-0.5">
          <span className="text-xs max-md:text-[9px] md:font-bold">
            {countDown?.seconds || 0}
          </span>
          <span className="text-xs max-md:text-[9px] md:font-bold">:</span>
          <span className="text-xs max-md:text-[9px] md:font-bold">
            {countDown?.minutes || 0}
          </span>
          <span className="text-xs max-md:text-[9px] md:font-bold">:</span>
          <span className="text-xs max-md:text-[9px] md:font-bold">
            {countDown?.hours || 0}
          </span>
        </span>
      </div>
    )
  );
};

export default ProductCardCountDown;
